import script from "./HeroScene.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroScene.vue?vue&type=script&setup=true&lang=js"

import "./HeroScene.vue?vue&type=style&index=0&id=b3a26baa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3a26baa"]])

export default __exports__